import { z } from 'zod';
import { INSTRUMENT_TYPE } from '@fortem-monorepo/constants';
import { ObservationFrequencySchema } from './autocall-standard.schema';
import { autocallBarrierStepSchema } from './shared/autocall-barrier-step.schema';
import { baseStructuredSchema } from './shared/base-structured.schema';
import { knockdownInputLevelSchema } from './shared/knockdown-input-level.schema';
import { payoffBarrierStepSchema } from './shared/payoff-barrier-step.schema';
export const phoenixNonMemorySchema = baseStructuredSchema.extend({
    instrument_type: z.literal(INSTRUMENT_TYPE.AutocallPhoenix),
    autocall_yearly_observations: ObservationFrequencySchema,
    coupon_yearly_observations: ObservationFrequencySchema,
    coupon_rate_annual: z.number(),
    autocall_barrier_level: z.number(),
    payoff_barrier_level: z.number(),
    knockdown_input_level: knockdownInputLevelSchema,
    autocall_barrier_step: autocallBarrierStepSchema,
    payoff_barrier_step: payoffBarrierStepSchema,
});
